import { render, staticRenderFns } from "./uploadImgs.vue?vue&type=template&id=5fa03124&scoped=true"
import script from "./uploadImgs.vue?vue&type=script&lang=js"
export * from "./uploadImgs.vue?vue&type=script&lang=js"
import style0 from "./uploadImgs.vue?vue&type=style&index=0&id=5fa03124&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa03124",
  null
  
)

export default component.exports